var _style, _defs, _polygon, _rect, _polygon2, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon3, _rect7, _rect8, _polygon4, _rect9, _rect10, _polygon5, _path, _path2, _rect11, _g, _g2, _rect12, _rect13, _path3, _path4, _path5, _path6, _path7, _rect14, _g3, _polygon6, _polygon7, _rect15, _rect16, _rect17, _polygon8, _polygon9, _rect18, _polygon10, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _polygon11, _polygon12, _rect27, _rect28, _rect29, _polygon13, _polygon14, _rect30, _polygon15, _rect31, _polygon16, _polygon17, _rect32, _rect33, _rect34, _polygon18, _g4, _polygon19, _polygon20, _polygon21, _rect35, _rect36, _rect37, _rect38, _g5, _rect39, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileMusicoTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 560 360",
    style: {
      enableBackground: "new 0 0 560 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000080184644746095897060000001600014240784504497_);}\n\t.st1{fill:#D3DA44;}\n\t.st2{fill:#F5EE79;}\n\t.st3{fill:#749947;}\n\t.st4{fill:#FADC2E;}\n\t.st5{fill:#AEBC36;}\n\t.st6{fill:#A8B415;}\n\t.st7{fill:#9EB135;}\n\t.st8{fill:#709851;}\n\t.st9{fill:none;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:#F2D42E;}\n\t.st12{clip-path:url(#SVGID_00000134965872301341049650000008963822877464535219_);fill:#F2F2F2;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: -18.9,
    width: 560,
    height: 360
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147217395925153187750000011224254927409183664_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147217395925153187750000011224254927409183664_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "271.5,334.5 308.6,334.5 308.6,220.5 271.5,235.4  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 332.1,
    y: 210.3,
    className: "st2",
    width: 33.1,
    height: 123.6
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "507.7,335.4 474.6,335.4 474.6,221.9 507.7,203.3  "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -123.9,
    y: 277.3,
    className: "st2",
    width: 42.9,
    height: 58.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -87.2,
    y: 297.6,
    className: "st2",
    width: 67.5,
    height: 34.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -64.2,
    y: 287.9,
    className: "st2",
    width: 67.5,
    height: 34.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.3,
    y: 216,
    className: "st1",
    width: 37.2,
    height: 119.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -144.7,
    y: 233.2,
    className: "st1",
    width: 42.9,
    height: 103.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "19.2,334.2 -23.7,334.2 -23.7,247.8 19.2,234.3  "
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -27.4,
    y: 294.4,
    className: "st3",
    width: 55.4,
    height: 40.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 273.1,
    className: "st3",
    width: 38.9,
    height: 61.7
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "15.8,332.8 -11.7,332.8 -11.7,262.4 15.8,275.9  "
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -179.9,
    y: 223.1,
    className: "st3",
    width: 39,
    height: 111.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -55.6,
    y: 310.2,
    className: "st3",
    width: 42.8,
    height: 23.3
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-171.6,335.1 -199,335.1 -199,277.3 -171.6,263.5  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-165,228c-1.1,0-2-0.9-2-2v-40c0-1.1,0.9-2,2-2s2,0.9,2,2v40C-162.9,227.1-163.8,228-165,228z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-156,228c-1.1,0-2-0.9-2-2v-16.4c0-1.1,0.9-2,2-2s2,0.9,2,2v16.4C-154,227.1-154.9,228-156,228z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -12.6,
    y: 203.8,
    transform: "matrix(0.5 -0.866 0.866 0.5 -184.3206 96.8308)",
    className: "st4",
    width: 8.5,
    height: 8.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-70.9,240.2c-2.6,0-4.7-2.1-4.7-4.6s2.1-4.6,4.7-4.6c2.6,0,4.7,2.1,4.7,4.6S-68.4,240.2-70.9,240.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-70.9,259.3c-13.1,0-23.7-10.6-23.7-23.7c0-13.1,10.6-23.7,23.7-23.7s23.7,10.6,23.7,23.7 C-47.2,248.6-57.8,259.3-70.9,259.3z M-70.9,214.5c-11.6,0-21,9.4-21,21s9.4,21,21,21s21-9.4,21-21 C-49.9,224-59.3,214.5-70.9,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-54.9,334.9l-31.6-0.4l12.9-100.8l5.8,0.8L-54.9,334.9z M-82.6,331.2l23.9,0.3l-12-93.3L-82.6,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-70.9,187.5c-2.8,0-5.2-2.3-5.2-5.2s2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2S-68.1,187.5-70.9,187.5z  M-70.9,179.9c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4S-69.6,179.9-70.9,179.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-70.9,294.6c-2.8,0-5.2-2.3-5.2-5.2c0-2.8,2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2 C-65.8,292.3-68.1,294.6-70.9,294.6z M-70.9,287c-1.3,0-2.4,1.1-2.4,2.5s1.1,2.5,2.4,2.5s2.4-1.1,2.4-2.5 C-68.5,288.1-69.6,287-70.9,287z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-35.4,199c-1.4,0-2.7-0.5-3.7-1.5c-1-1-1.5-2.3-1.5-3.6c0-1.4,0.5-2.7,1.5-3.6c1-1,2.3-1.5,3.7-1.5 s2.7,0.5,3.6,1.5c1,1,1.5,2.3,1.5,3.6c0,1.4-0.5,2.7-1.5,3.6l0,0l0,0l0,0C-32.7,198.4-34,199-35.4,199z M-35.4,191.4 c-0.7,0-1.3,0.3-1.7,0.7s-0.7,1.1-0.7,1.7s0.3,1.3,0.7,1.7c0.9,0.9,2.5,0.9,3.5,0l0,0c0.5-0.5,0.7-1.1,0.7-1.7 s-0.3-1.3-0.7-1.7C-34.1,191.6-34.8,191.4-35.4,191.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-111.2,274.7c-1.4,0-2.7-0.5-3.7-1.5c-2-2-2-5.3,0-7.3c1-1,2.3-1.5,3.7-1.5c1.4,0,2.7,0.5,3.7,1.5 c1,1,1.5,2.3,1.5,3.6s-0.5,2.7-1.5,3.6l0,0l0,0l0,0C-108.5,274.2-109.8,274.7-111.2,274.7z M-111.2,267.1 c-0.7,0-1.3,0.3-1.7,0.7c-0.5,0.5-0.7,1.1-0.7,1.7c0,0.6,0.2,1.3,0.7,1.7c0.9,0.9,2.5,0.9,3.5,0l0,0c0.5-0.5,0.7-1.1,0.7-1.7 c0-0.6-0.3-1.3-0.7-1.7C-109.9,267.4-110.5,267.1-111.2,267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-17.7,241.4c-2.8,0-5.2-2.3-5.2-5.2c0-2.8,2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2 C-12.6,239.1-14.9,241.4-17.7,241.4z M-17.7,233.8c-1.4,0-2.5,1.1-2.5,2.4c0,1.4,1.1,2.4,2.5,2.4s2.4-1.1,2.4-2.4 C-15.3,234.9-16.4,233.8-17.7,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-124.8,241.4c-2.8,0-5.2-2.3-5.2-5.2c0-2.8,2.3-5.2,5.2-5.2c2.8,0,5.2,2.3,5.2,5.2 C-119.7,239.1-122,241.4-124.8,241.4z M-124.8,233.8c-1.3,0-2.4,1.1-2.4,2.4c0,1.4,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4 C-122.4,234.9-123.5,233.8-124.8,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-34.6,277.8c-1.4,0-2.7-0.5-3.7-1.5l0,0l0,0l0,0c-1-1-1.5-2.3-1.5-3.6s0.5-2.7,1.5-3.6 c1-1,2.3-1.5,3.7-1.5s2.7,0.5,3.6,1.5c2,2,2,5.3,0,7.3C-31.9,277.2-33.2,277.8-34.6,277.8z M-34.6,270.2 c-0.7,0-1.3,0.3-1.7,0.7s-0.7,1.1-0.7,1.7c0,0.6,0.3,1.3,0.7,1.7l0,0c0.9,0.9,2.5,0.9,3.5,0c0.5-0.5,0.7-1.1,0.7-1.7 c0-0.6-0.2-1.3-0.7-1.7C-33.3,270.4-33.9,270.2-34.6,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-110.3,202c-1.4,0-2.7-0.5-3.7-1.5l0,0l0,0l0,0c-1-1-1.5-2.3-1.5-3.6c0-1.4,0.5-2.7,1.5-3.6 c1-1,2.3-1.5,3.7-1.5c1.4,0,2.7,0.5,3.7,1.5c1,1,1.5,2.3,1.5,3.6c0,1.4-0.5,2.7-1.5,3.6C-107.7,201.5-108.9,202-110.3,202z  M-110.3,194.4c-0.7,0-1.3,0.3-1.7,0.7c-0.5,0.5-0.7,1.1-0.7,1.7s0.3,1.3,0.7,1.7l0,0c0.9,0.9,2.5,0.9,3.5,0 c0.5-0.5,0.7-1.1,0.7-1.7s-0.3-1.3-0.7-1.7C-109.1,194.7-109.7,194.4-110.3,194.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -72.6,
    y: 191.4,
    className: "st6",
    width: 3.4,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -72.6,
    y: 218.4,
    className: "st6",
    width: 3.4,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: 233.9,
    className: "st6",
    width: 21.8,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -89.3,
    y: 233.9,
    className: "st6",
    width: 36.1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -115.1,
    y: 233.9,
    className: "st6",
    width: 21.8,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -48.9,
    y: 249,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -197.5889 42.7221)",
    className: "st6",
    width: 3.4,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -73.1,
    y: 217.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -187.585 18.5728)",
    className: "st6",
    width: 3.4,
    height: 36.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96.4,
    y: 201.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -177.9286 -4.7362)",
    className: "st6",
    width: 3.4,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -107.1,
    y: 257.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -211.4908 7.9614)",
    className: "st6",
    width: 21.8,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -89.4,
    y: 233.8,
    transform: "matrix(0.724 -0.6898 0.6898 0.724 -182.1121 15.7866)",
    className: "st6",
    width: 36.1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -58.9,
    y: 210.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -164.0722 28.1888)",
    className: "st6",
    width: 21.8,
    height: 3.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-70.9,281c-25,0-45.4-20.4-45.4-45.4s20.4-45.4,45.4-45.4s45.4,20.4,45.4,45.4S-45.9,281-70.9,281z  M-70.9,194.9c-22.4,0-40.7,18.2-40.7,40.7s18.2,40.7,40.7,40.7s40.7-18.2,40.7-40.7S-48.5,194.9-70.9,194.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M534.7,249.4c-0.1,0-0.2-0.1-0.2-0.2v-11.9c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v11.9 C534.9,249.4,534.8,249.4,534.7,249.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "534.7,247.5 524.8,273 544.7,273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "534.7,247.5 524.8,273 531.5,273  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M534.7,237.4c4.5-1.9,7.2,5.2,10.9-1.1c0,0.9-1.1,4.6-5.4,4.4c1,1.3,3.7,1.7,5.4,0.2 c-4.8,4.9-6.9-0.9-10.9,1.2V237.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 280.4,
    className: "st1",
    width: 16.6,
    height: 53.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 278.5,
    className: "st1",
    width: 16.6,
    height: 1.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "524.2,275 526.4,278.5 543,278.5 545.2,275  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 300.2,
    className: "st1",
    width: 16.6,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 320,
    className: "st1",
    width: 16.6,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539,
    y: 312.8,
    className: "st1",
    width: 1.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539,
    y: 284.6,
    className: "st1",
    width: 1.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.2,
    y: 305.2,
    className: "st1",
    width: 1.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.2,
    y: 291.6,
    className: "st1",
    width: 1.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539,
    y: 307.7,
    className: "st1",
    width: 2.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.7,
    y: 315.3,
    className: "st1",
    width: 2.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.8,
    y: 329.9,
    className: "st1",
    width: 2.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 329.9,
    className: "st1",
    width: 1.3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 327.5,
    className: "st1",
    width: 2.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.1,
    y: 325.9,
    className: "st1",
    width: 2.7,
    height: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "543,269.7 543,271.8 541.6,271.8 541.6,269.7 539.9,269.7 539.9,271.8 538.5,271.8 538.5,269.7  536.8,269.7 536.8,271.8 535.4,271.8 535.4,269.7 533.6,269.7 533.6,271.8 532.2,271.8 532.2,269.7 530.5,269.7 530.5,271.8  529.1,271.8 529.1,269.7 527.4,269.7 527.4,271.8 526,271.8 526,269.7 524.2,269.7 524.2,274.4 545.2,274.4 545.2,269.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "543,270.3 543,272.4 541.6,272.4 541.6,270.3 539.9,270.3 539.9,272.4 538.5,272.4 538.5,270.3  536.8,270.3 536.8,272.4 535.4,272.4 535.4,270.3 533.6,270.3 533.6,272.4 532.2,272.4 532.2,270.3 530.5,270.3 530.5,272.4  529.1,272.4 529.1,270.3 527.4,270.3 527.4,272.4 526,272.4 526,270.3 524.2,270.3 524.2,275 545.2,275 545.2,270.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "541.6,276 540.4,278.5 541.8,278.5 543,276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "539.3,278.5 537.9,278.5 538.6,276 540,276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "536.7,278.5 535.3,278.5 535.5,276 536.9,276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "534.1,278.5 532.7,278.5 532.5,276 533.9,276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "531.6,278.5 530.2,278.5 529.5,276 530.9,276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "526.4,276 527.8,276 529,278.5 527.6,278.5  "
  })))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 674.4,
    y: 244,
    className: "st2",
    width: 30.1,
    height: 69.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 571.7,
    y: 259.3,
    className: "st1",
    width: 54.3,
    height: 76.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49_00000025441863614760230260000003099507510230167483_",
    className: "st5",
    d: "M634.2,217.8l-0.2,3.9l-5.2,114.2H665 l-5.2-114.1l-0.2-3.9L634.2,217.8L634.2,217.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60_00000054235099691867646980000016393597272505255313_",
    className: "st6",
    d: "M636,217.8h-16.5l-0.4,3.9l-11.9,114.2 h23.5l5.2-114.1L636,217.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61_00000179634097095736481130000007608449356701608604_",
    className: "st7",
    d: "M674.8,221.8l-0.4-3.9h-16.5l0.2,3.9 l5.2,114.2h23.5L674.8,221.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50_00000183217800941128558540000004860282035199440038_",
    className: "st5",
    d: "M675.9,216.3l0.4,1.7H617l0.4-1.7H675.9z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M676.3,191.6v10.5H670v-10.5h-11.2v10.5h-6.3v-10.5h-11.7v10.5h-6.3v-10.5h-11.2v10.5H617v-10.5h-7.4v24.7 h74.2v-24.7H676.3z M630.5,211.5h-3.8v-5.1c0-1.1,0.8-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9L630.5,211.5L630.5,211.5z M648.6,211.5 h-3.8v-5.1c0-1.1,0.8-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9L648.6,211.5L648.6,211.5z M666.7,211.5h-3.8v-5.1c0-1.1,0.8-1.9,1.9-1.9 c1,0,1.9,0.9,1.9,1.9L666.7,211.5L666.7,211.5z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 538.7,
    y: 304,
    className: "st1",
    width: 42.9,
    height: 30.7
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M728.3,242.7c-0.1,0-0.2-0.1-0.2-0.2v-13.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v13.1 C728.5,242.6,728.4,242.7,728.3,242.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "728.3,240.5 717.3,268.7 739.3,268.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "728.3,240.5 717.3,268.7 724.7,268.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M728.3,229.4c4.9-2.1,7.9,5.8,12-1.2c0,1-1.2,5.1-6,4.8c1.2,1.5,4,1.9,6,0.2c-5.3,5.4-7.7-1-12,1.3V229.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.2,
    y: 276.9,
    className: "st1",
    width: 18.3,
    height: 58.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.2,
    y: 274.8,
    className: "st1",
    width: 18.3,
    height: 2.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "716.8,270.9 719.2,274.8 737.5,274.8 739.9,270.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.2,
    y: 298.8,
    className: "st1",
    width: 18.3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.2,
    y: 320.6,
    className: "st1",
    width: 18.3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.1,
    y: 312.6,
    className: "st1",
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.1,
    y: 281.5,
    className: "st1",
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722.2,
    y: 304.2,
    className: "st1",
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722.2,
    y: 289.2,
    className: "st1",
    width: 1.9,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.1,
    y: 307,
    className: "st1",
    width: 3,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721.7,
    y: 315.4,
    className: "st1",
    width: 3,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 727.3,
    y: 331.6,
    className: "st1",
    width: 3,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.2,
    y: 331.6,
    className: "st1",
    width: 1.5,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 723.1,
    y: 328.9,
    className: "st1",
    width: 3,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 727.7,
    y: 327.1,
    className: "st1",
    width: 3,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "737.5,265.1 737.5,267.4 736,267.4 736,265.1 734,265.1 734,267.4 732.5,267.4 732.5,265.1  730.6,265.1 730.6,267.4 729.1,267.4 729.1,265.1 727.1,265.1 727.1,267.4 725.6,267.4 725.6,265.1 723.7,265.1 723.7,267.4  722.2,267.4 722.2,265.1 720.2,265.1 720.2,267.4 718.7,267.4 718.7,265.1 716.8,265.1 716.8,270.2 739.9,270.2 739.9,265.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "737.5,265.7 737.5,268 736,268 736,265.7 734,265.7 734,268 732.5,268 732.5,265.7 730.6,265.7  730.6,268 729.1,268 729.1,265.7 727.1,265.7 727.1,268 725.6,268 725.6,265.7 723.7,265.7 723.7,268 722.2,268 722.2,265.7  720.2,265.7 720.2,268 718.7,268 718.7,265.7 716.8,265.7 716.8,270.9 739.9,270.9 739.9,265.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "735.9,272 734.6,274.8 736.2,274.8 737.5,272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "733.4,274.8 731.8,274.8 732.6,272 734.1,272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "730.5,274.8 729,274.8 729.2,272 730.8,272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "727.7,274.8 726.1,274.8 725.9,272 727.4,272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "724.8,274.8 723.3,274.8 722.5,272 724.1,272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "719.2,272 720.7,272 722,274.8 720.5,274.8  "
  })))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "592.8,336.5 553.8,336.5 553.8,233.4 592.8,247  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "337.4,335.7 298.4,335.7 298.4,217.7 337.4,233.2  "
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 308,
    className: "st3",
    width: 27.4,
    height: 30.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 694.9,
    y: 261.4,
    className: "st3",
    width: 27.4,
    height: 70.4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 677.7,
    y: 312.4,
    className: "st3",
    width: 42.8,
    height: 23.3
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "624.5,335.2 581.6,335.2 581.6,301.2 624.5,314.8  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "533.4,336.5 570.2,336.5 570.2,302.6 533.4,316.1  "
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: -149.2,
    y: 297.5,
    className: "st3",
    width: 42.8,
    height: 37.6
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-83.9,333.4 -110.5,333.4 -109.2,307.3 -84.6,318  "
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9,
    y: 218.7,
    className: "st5",
    width: 3.9,
    height: 54.3
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: 232.3,
    className: "st5",
    width: 3.9,
    height: 40.7
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 236.2,
    className: "st1",
    width: 31.5,
    height: 97.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 374.7,
    y: 238.8,
    className: "st1",
    width: 33.1,
    height: 94.4
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 263.7,
    className: "st1",
    width: 33.1,
    height: 70.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 462.3,
    y: 234.8,
    className: "st1",
    width: 33.1,
    height: 98.7
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 268.7,
    className: "st1",
    width: 31.5,
    height: 65
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 242.6,
    y: 254.8,
    className: "st2",
    width: 28.7,
    height: 77.6
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "244.3,332.4 215.6,332.4 215.6,239.2 244.3,248.1  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "443.5,334.2 413.4,334.2 413.4,261.7 443.5,268.7  "
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 92.4,
    y: 293.4,
    className: "st8",
    width: 26.1,
    height: 39.6
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 253.4,
    className: "st3",
    width: 32.5,
    height: 79.7
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 247.5,
    y: 276.1,
    className: "st1",
    width: 26.1,
    height: 57.4
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "166.9,245.4 137.1,331 196.9,331 211.1,331 196.9,159.8  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "226.6,245.4 196.6,159.8 196.6,159.8 210.9,331 256.6,331  "
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 258.6,
    y: 288.9,
    className: "st8",
    width: 56.3,
    height: 44
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "227.7,333.3 268.5,333.3 268.5,300.9 227.7,313.8  "
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 353.6,
    y: 289.4,
    className: "st8",
    width: 36,
    height: 44.6
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "321.2,334.4 364,334.4 364,300.4 321.2,313.9  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "159.4,333.3 118.6,333.3 118.6,293.3 159.4,309.2  "
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 181.9,
    y: 214,
    transform: "matrix(0.9245 -0.3813 0.3813 0.9245 -67.5826 89.4717)",
    className: "st7",
    width: 20.2,
    height: 2.6
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 174.1,
    y: 256.4,
    transform: "matrix(0.921 -0.3897 0.3897 0.921 -85.2888 94.972)",
    className: "st7",
    width: 34.8,
    height: 2.6
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 302.8,
    transform: "matrix(0.9575 -0.2886 0.2886 0.9575 -79.2023 70.8624)",
    className: "st7",
    width: 23.5,
    height: 2.6
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "463.2,334 418.6,334 430.1,286.3 463.2,286.3  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M385.2,217.2c13.4-6.2,27.5-10.8,41.8-14.1c3.1-0.7,31.6-7,27.4,0.6c-0.9,1.2-2.2,2-3.4,2.7 c-3.2,1.9-6.6,3.3-10.1,4.6c4-2.1,8.2-4.1,11.6-7.1c1.6-1.6,1.2-2-0.9-2.3c-4.5-0.4-9,0.5-13.4,1.2c-3.6,0.6-7.2,1.4-10.8,2.2 C413.2,208.3,399.1,212.5,385.2,217.2L385.2,217.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "423.3,335.3 403.4,335.3 408.8,219.3 417.9,219.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 413.3,
    cy: 215,
    r: 17.3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 413.3,
    cy: 176.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 413.3,
    cy: 157.9,
    r: 2.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 413.3,
    y1: 218.5,
    x2: 413.3,
    y2: 148.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "411.6,218.5 413.3,148.5 415,218.5  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M397.1,221.5c0.5,1.3,1.2,2.6,2.1,3.7c11.1-2.4,22.1-6.1,29.1-9.4C417.8,217.5,407.5,219.6,397.1,221.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M428.4,215.9c-11,4.7-22.5,8.1-34.1,10.7c-3.2,0.6-26.6,5.6-25-0.6c0.9-1.9,2.9-2.8,4.5-3.7 c1.3-0.7,2.7-1.3,4.1-1.9c-2.4,1.5-5.2,3-7.1,5.2c-3.3,3.8,12.9,1,14.4,0.7C399.8,223.8,414.1,219.9,428.4,215.9L428.4,215.9z"
  }))), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "540.7,335.8 463,335.8 463,298.8 527.2,298.8  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "506.1,333.8 478.7,333.8 478.7,263.4 506.1,276.9  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "479.7,334.5 410.6,334.5 418,311.2 479.7,311.2  "
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 360.4,
    y: 304.5,
    className: "st8",
    width: 36,
    height: 29.5
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 465.4,
    y: 202,
    transform: "matrix(6.835618e-03 -1 1 6.835618e-03 282.2248 690.9413)",
    className: "st2",
    width: 47,
    height: 2.7
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 202,
    transform: "matrix(6.835618e-03 -1 1 6.835618e-03 144.7378 552.5063)",
    className: "st2",
    width: 47,
    height: 2.7
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: -199,
    y: 320.4,
    className: "st3",
    width: 942.5,
    height: 30.1
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.4,
    y: 98.8,
    className: "st8",
    width: 5.4,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 41.1,
    className: "st8",
    width: 5.4,
    height: 5.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9444 -0.3289 0.3289 0.9444 -5.9778 116.4084)",
    className: "st8",
    cx: 341.1,
    cy: 75.9,
    rx: 1.4,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M315.2,50.9l-3.4-4c-0.5-0.6-1-1.1-1.6-1.6c-4.6-3.6-11.3-2.8-14.9,1.9c-10.6,14-18.3,36.3,0,58.1l15.1-9.1 c-1.2-1-2-1.8-2-1.8C290.7,73.1,312.7,53.1,315.2,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M316.8,92.5l6.5-4c-4.8-6.5-5.9-13-3.1-19.3c1.7-3.9,4.3-6.6,5.5-7.7l-5.2-5.5 C316.5,59.8,303.7,74.3,316.8,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M337,80.1l-1.2-1.6l0,0c-0.4-0.6-1.9-3.6,0-6.2l-4.8-5c-2.1,2.4-4.9,8.3-1.1,14.7l0,0l1.1,1.8L337,80.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3289 -0.9444 0.9444 0.3289 77.7381 260.6667)",
    className: "st8",
    cx: 222.3,
    cy: 75.6,
    rx: 1.6,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M268,47c-3.6-4.6-10.2-5.5-14.9-1.9c-0.6,0.5-1.1,1-1.6,1.6l-3.4,4c2.6,2.2,24.6,22.2,6.7,43.5 c0,0-0.8,0.9-2,1.8l15.1,9.1C286.3,83.2,278.5,61,268,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246.6,92.3l-6.5-4c4.8-6.5,5.9-13,3.1-19.3c-1.7-3.9-4.3-6.6-5.5-7.7l5.2-5.5C246.9,59.5,259.7,74,246.6,92.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M232.3,67l-4.8,5c1.9,2.7,0.3,5.6,0,6.2l0,0l-1.2,1.6l6,3.7l1.1-1.8l0,0C237.2,75.3,234.4,69.4,232.3,67z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.6,
    y: 73.2,
    className: "st10",
    width: 12.5,
    height: 4.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.7,
    y: 81.7,
    className: "st10",
    width: 12.6,
    height: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M311.4,156.4h-5.1v5.3h5.1c1.9,0,3.1-0.2,3.1-2.4v-0.4C314.5,156.7,313.4,156.4,311.4,156.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M282.3,130.5l-7.5-0.6c-1.4-0.1-1.9-0.5-1.9-1.7s0.6-1.6,2.1-1.6h6.2c1,0,1.6,0.4,1.9,1.3c0.2,0.6,0.4,1,1,1 h4c0.6,0,1-0.4,1-1c-0.3-4.4-2.8-6.9-7.8-6.9H275c-3.8,0-6,1.2-7.1,3.4h2.3v4.1h-3c0.1,4.2,2.1,6,7,6.4l7.5,0.6 c1.4,0.1,1.9,0.5,1.9,1.7c0,1.2-0.6,1.6-2.1,1.6h-6.7c-1,0-1.6-0.4-1.9-1.3c-0.2-0.6-0.4-1-1-1h-4c-0.6,0-1,0.4-1,1 c0.3,4.4,2.8,6.9,7.8,6.9h6.7c5.6,0,7.9-2.7,7.9-7.2C289.4,132.8,287.4,130.8,282.3,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M298.9,131.9v-10c0-0.6-0.4-1-1-1H294c-0.6,0-1,0.4-1,1v21.4c0,0.6,0.4,1,1,1h3.9c0.6,0,1-0.4,1-1v-7.3h-2.6 V132L298.9,131.9L298.9,131.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M256.4,152.1h-14.3c-0.5,0-0.8,0.3-0.8,0.8v2.8c0,0.5,0.3,0.8,0.8,0.8h4.9v5.1h2v4.1h-2v3.6 c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8v-12.8h4.9c0.5,0,0.8-0.3,0.8-0.8v-2.8C257.1,152.4,256.9,152.1,256.4,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M271.6,152.1h-6.7c-4.1,0-6,2.5-6,6.2v5.6c0,3.6,2,6.2,6,6.2h6.7c1,0,1.9-0.2,2.6-0.4v-3.1h3 c0.3-0.8,0.4-1.7,0.4-2.7v-5.6C277.6,154.6,275.6,152.1,271.6,152.1z M273.1,164c0,1.5-0.6,1.7-1.5,1.7h-6.7 c-0.9,0-1.5-0.2-1.5-1.7v-0.3h-2.9v-4.1h2.9v-1.5c0-1.6,0.5-1.7,1.5-1.7h6.7c1,0,1.5,0.2,1.5,1.7V164z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M297.8,152.1h-3c-0.5,0-0.8,0.3-0.8,0.8V164c0,1.5-0.6,1.7-1.5,1.7h-5.9c-0.9,0-1.5-0.2-1.5-1.7v-4h-0.9 v-4.1h-1.5l0,0h2.5v-3.1c0-0.5-0.3-0.8-0.8-0.8h-3c-0.5,0-0.8,0.3-0.8,0.8v11c0,3.6,2,6.2,6,6.2h5.9c4.1,0,6-2.5,6-6.2v-11 C298.5,152.4,298.2,152.1,297.8,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319,157.2c-0.5-3.3-2.8-5.1-7.1-5.1h-9.2c-0.5,0-0.8,0.3-0.8,0.8v9h0v4.1h3.2l0,0h-3.2v3.3 c0,0.5,0.3,0.8,0.8,0.8h3c0.5,0,0.8-0.3,0.8-0.8V166h4.9l2.2,3.6c0.2,0.4,0.5,0.5,0.9,0.5h3.4c0.6,0,0.8-0.4,0.5-0.9l-2.6-3.7 c1.8-0.7,2.8-2.2,3.2-4.1h-1.8v-4.1H319z M314.5,159.3c0,2.2-1.2,2.4-3.1,2.4h-5.1v-5.3h5.1c2,0,3.1,0.3,3.1,2.4V159.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.5,
    y: 161.5,
    className: "st11",
    width: 2.1,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.1,
    y: 159.6,
    className: "st11",
    width: 2.9,
    height: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M323.8,157.2H322v4.1h1.8c0.1-0.6,0.2-1.3,0.2-2v-0.5C323.9,158.3,323.9,157.7,323.8,157.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M345.3,121h-8.7c-4,0-6.4,1.8-7.4,4.8c-0.3,1-0.5,2.1-0.5,3.3v0.8v6.5c0,4.7,2.5,8.1,7.9,8.1h8.7 c5.3,0,7.9-3.3,7.9-8.1v-7.3C353.1,124.3,350.6,121,345.3,121z M351.2,136.1h-4v0.4c0,2-0.8,2.2-2,2.2h-8.7c-1.2,0-2-0.2-2-2.2 v-7.7c0-2,0.7-2.2,2-2.2h8.7c1.3,0,2,0.2,2,2.2v3.1h4V136.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.7,
    y: 132,
    className: "st8",
    width: 4,
    height: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M320.8,130h3.9c0.6,0,1-0.3,1-0.9c0-4.8-2.5-8.1-7.9-8.1h-7.4c-5.3,0-7.9,3.3-7.9,8.1v2.9h1.3v4.1h-1.3v0.3 c0,4.7,2.5,8.1,7.9,8.1h3h0.1h4.2c2.6,0,4.6-0.8,5.9-2.2h0.1c1.3-1.4,1.9-3.4,1.9-5.8v-0.7c0-0.4-0.4-0.6-1-0.6h-3.9 c-0.6,0-1,0.4-1,1v0.5c0,2-0.8,2.2-2,2.2h-7.4c-1.2,0-2-0.2-2-2.2v-7.7c0-2,0.7-2.2,2-2.2h7.4c1.3,0,2,0.2,2,2.2v0.6 C319.8,129.8,320.2,130,320.8,130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.5,121h-4.7c-0.5,0-0.9,0.2-1.2,0.7l-7.1,12l-7.2-12c-0.3-0.5-0.7-0.7-1.2-0.7h-4.7c-0.6,0-1,0.4-1,1v5.7 h3.6v4.1h-3.6v11.6c0,0.6,0.4,1,1,1h3.9c0.6,0,1-0.4,1-1v-13l5.8,9.6c0.3,0.5,0.7,0.7,1.2,0.7h2.3c0.5,0,0.9-0.2,1.2-0.7l5.9-9.7 v13.1c0,0.6,0.4,1,1,1h3.9c0.6,0,1-0.4,1-1v-2.7h-0.1v-4.1h0.1V122C235.5,121.3,235.1,121,234.5,121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M262.2,121h-3.9c-0.6,0-1,0.4-1,1v14.6c0,2-0.8,2.2-2,2.2h-7.7c-1.2,0-2-0.2-2-2.2V122c0-0.6-0.4-1-1-1h-3.9 c-0.6,0-1,0.4-1,1v14.4c0,0.1,0,0.1,0,0.2h2.2v4.1h-1.2c1.2,2.3,3.5,3.7,6.9,3.7h7.7c5.3,0,7.9-3.3,7.9-8.1v-7.8h0v-4.1h0V122 C263.2,121.3,262.9,121,262.2,121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.3,
    y: 127.8,
    className: "st8",
    width: 3.6,
    height: 4.1
  })))), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    y: 334.8,
    className: "st3",
    width: 560.2,
    height: 26.4
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000068646460602885025600000004520159446133361031_",
    width: 560.2,
    height: 361.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129913510670885064350000013855428401133623947_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068646460602885025600000004520159446133361031_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 445.7,
    y: -31.9,
    transform: "matrix(0.9714 0.2374 -0.2374 0.9714 31.5365 -127.4131)",
    style: {
      clipPath: "url(#SVGID_00000129913510670885064350000013855428401133623947_)",
      fill: "#F2F2F2"
    },
    width: 198.4,
    height: 198.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -99.2,
    y: 58,
    transform: "matrix(0.7905 0.6124 -0.6124 0.7905 96.2648 32.9251)",
    style: {
      clipPath: "url(#SVGID_00000129913510670885064350000013855428401133623947_)",
      fill: "#F2F2F2"
    },
    width: 198.4,
    height: 198.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileMusicoTour);
export default __webpack_public_path__ + "static/media/tile-MusicoTour.fe2e79de65806378e603e1dcf3d3b3f7.svg";
export { ForwardRef as ReactComponent };